// dependencies imports ⇒
import React, { useState } from "react";
import { ClickAwayListener } from "@material-ui/core";
// assets and scss imports ⇒
import "./editableLabel.scss";
import EditIcon from "../../../../assets/edit_icon.svg";
import CloseIcon from "../../../../assets/close_icon_red.svg";
import TickIcon from "../../../../assets/tick_green.svg";
// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const EditableLabel = (props) => {
  // const declarations ⇒
  const { title, handleEditInputChange, toggleSections, comp } = props;
  const [isEdited, setIsEdited] = useState(false);
  const [inputValue, setInputValue] = useState("");

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒

  const handleEditLabel = () => {
    setInputValue(title);
    setIsEdited(true);
  };

  const handleEditClose = () => {
    setIsEdited(false);
  };

  const handleInputChange = (e) => {
    let regex = /^[a-zA-Z0-9 ]*$/;
    let value = e.target.value;
    if (regex.test(value)) {
      setInputValue(value);
    }
  };

  const handleSaveLabel = () => {
    handleEditInputChange && handleEditInputChange(inputValue);
    setIsEdited(false);
  };

  // create UI ⇒

  const editableLabelUI = () => {
    return (
      <>
        {!isEdited ? (
          <div className="el-container">
            <div className="el-title" onClick={() => toggleSections(comp)}>
              {title}
            </div>
            <div className="el-icon">
              <img src={EditIcon} alt="" onClick={handleEditLabel} />
            </div>
          </div>
        ) : (
          <ClickAwayListener onClickAway={handleEditClose}>
            <div className="el-input-icon-container">
              <div className="el-input-container">
                <input
                  value={inputValue}
                  className="el-input"
                  maxLength={30}
                  onChange={handleInputChange}
                />
              </div>
              <div className="el-input-icons-cross">
                <img src={CloseIcon} alt="" onClick={handleEditClose} />
              </div>
              <div className="el-input-icons-tick">
                <img src={TickIcon} alt="" onClick={handleSaveLabel} />
              </div>
            </div>
          </ClickAwayListener>
        )}
      </>
    );
  };

  return <div className="editable-label">{editableLabelUI()}</div>;
};

// export ⇒

export default EditableLabel;
